import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_AUTOMATED_TESTS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch automated tests.'),
      403: i18n.t('You are not allowed to fetch automated tests.'),
      404: i18n.t('The automated tests you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the automated tests.'),
      default: i18n.t('An error occurred fetching the automated tests.')
    }
  },
  FETCH_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch this automated test.'),
      403: i18n.t('You are not allowed to fetch this automated test.'),
      404: i18n.t('The automated test you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the automated test.'),
      default: i18n.t('An error occurred fetching the automated test.')
    }
  },
  CREATE_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to create an automated test.'),
      403: i18n.t('You are not allowed to create an automated test.'),
      404: i18n.t('The resource needed to create the automated test was not found.'),
      500: i18n.t('An error occurred creating the automated test.'),
      default: i18n.t('An error occurred creating the automated test.')
    },
    SUCCESS: {
      200: i18n.t('Automated test created successfully.')
    }
  },
  UPDATE_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to update this automated test.'),
      403: i18n.t('You are not allowed to update this automated test.'),
      404: i18n.t('The automated test you are trying to update does not exist.'),
      500: i18n.t('An error occurred updating the automated test.'),
      default: i18n.t('An error occurred updating the automated test.')
    },
    SUCCESS: {
      200: i18n.t('Automated test updated successfully.')
    }
  },
  DELETE_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to delete this automated test.'),
      403: i18n.t('You are not allowed to delete this automated test.'),
      404: i18n.t('The automated test you are trying to delete does not exist.'),
      500: i18n.t('An error occurred deleting the automated test.'),
      default: i18n.t('An error occurred deleting the automated test.')
    },
    SUCCESS: {
      200: i18n.t('Automated test deleted successfully.')
    }
  },
  RUN_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to run this automated test.'),
      403: i18n.t('You are not allowed to run this automated test.'),
      404: i18n.t('The automated test you are trying to run does not exist.'),
      500: i18n.t('An error occurred while starting the test run.'),
      default: i18n.t('An error occurred while starting the test run.')
    },
    SUCCESS: {
      200: i18n.t('Automated test run started successfully.')
    }
  },
  CLONE_AUTOMATED_TEST: {
    ERROR: {
      401: i18n.t('You are not authorized to clone this automated test.'),
      403: i18n.t('You are not allowed to clone this automated test.'),
      404: i18n.t('The automated test you are trying to clone does not exist.'),
      500: i18n.t('An error occurred cloning the automated test.'),
      default: i18n.t('An error occurred cloning the automated test.')
    },
    SUCCESS: {
      200: i18n.t('Automated test cloned successfully.')
    }
  },
  FETCH_AUTOMATED_TEST_RESULTS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch test results.'),
      403: i18n.t('You are not allowed to fetch test results.'),
      404: i18n.t('The test results you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the test results.'),
      default: i18n.t('An error occurred fetching the test results.')
    }
  },
  FETCH_AUTOMATED_TEST_RESULT: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch this test result.'),
      403: i18n.t('You are not allowed to fetch this test result.'),
      404: i18n.t('The test result you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the test result.'),
      default: i18n.t('An error occurred fetching the test result.')
    }
  },
  DELETE_AUTOMATED_TEST_RESULT: {
    ERROR: {
      401: i18n.t('You are not authorized to delete this test result.'),
      403: i18n.t('You are not allowed to delete this test result.'),
      404: i18n.t('The test result you are trying to delete does not exist.'),
      500: i18n.t('An error occurred deleting the test result.'),
      default: i18n.t('An error occurred deleting the test result.')
    },
    SUCCESS: {
      200: i18n.t('Test result deleted successfully.')
    }
  }
};
